module.exports = __webpack_public_path__ + "img/2813d8c.svg";